import config from "../config/config";

const url = config.URL_VALIDATE_TOKEN;

const validateToken = async (jwt2) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      jwt2:jwt2,
    }),
  };

  try {
    return  fetch(url, requestOptions).then(async (response) => {
      if (response.status !== 200) return null;
      return true;
    });
  } catch (error) {
    return null;
  }
};

export default validateToken;
